import { z } from 'zod';

export const paginationSchema = z.object({
  pageSize: z
    .string()
    .default('25')
    .transform(x => parseInt(x)),
  pageIndex: z
    .string()
    .default('1')
    .transform(x => parseInt(x)),
});
